export default function validate(values) {
  let errors = {};

  if (!values.name) {
    errors.name = 'A folder name is required';
  } 
  
  return errors;
};